import { render } from "./Depts.vue?vue&type=template&id=b2f9de12"
import script from "./Depts.vue?vue&type=script&lang=js"
export * from "./Depts.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/INNCOM/MUSOON Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__